import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CircleCheck, XCircle, Info, AlertTriangle } from 'lucide-react';
import './App.scss';
import { NewOrder } from './components/newOrder';
import ScrollToTop from './components/ScrollToTop';
import DevEnvIndicator from './components/DevEnvIndicator';
import AuthenticatedApp from './pages/AuthenticatedApp';
import Login from './pages/login';
import SetPassword from './pages/SetPassword';
import Signup from './pages/signup';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Eula from './pages/Eula';

const App = () => {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/signup">
          <Signup />
        </Route>
        <Route exact path="/set-password">
          <SetPassword />
        </Route>
        <Route exact path="/privacy-policy">
          <PrivacyPolicy />
        </Route>
        <Route exact path="/eula">
          <Eula />
        </Route>
        <Route path="/new-order">
          <NewOrder />
        </Route>
        <Route path="/">
          <AuthenticatedApp />
        </Route>
      </Switch>
      <DevEnvIndicator />
      <Toaster
        position="bottom-right"
        duration={3000}
        icons={{
          success: <CircleCheck size={20} color="white" fill="black" />,
          error: <XCircle size={20} color="white" fill="black" />,
          info: <Info size={20} color="white" fill="black" />,
          warning: <AlertTriangle size={20} color="white" fill="black" />
        }}
        toastOptions={{
          style: {
            background: '#ffffff',
            color: '#333333',
            borderRadius: '8px',
            fontWeight: 600,
            fontSize: '13px',
            padding: '10px 12px'
          }
        }}
      />
    </>
  );
};

export default App;
